import type { TemplateMeta } from '../../types';
import { Box3RowIcon } from './Icon';

export const yearlyMonthCardMeta: TemplateMeta = {
  name: '12 Box Grid',
  orientation: 'portrait',
  Icon: Box3RowIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Date range',
  eventListDisplayFullLabel: 'Full year',
  eventListRangePicker: 'month-range',
};
